export default __webpack_public_path__ + "static/media/add-money-sidebar.2a56b5c5.svg";